/** Shared labels and navigation eligibility; APIs enforce actual domain authority. */
export const governanceNavigation: Record<string, { en: string; ar: string; capabilities: string[] }> = {
  "/config-governance": { en: "Configuration review", ar: "مراجعة الإعدادات", capabilities: ["configs.view"] },
  "/machine-identities": { en: "Service identities", ar: "هويات الأنظمة", capabilities: ["domains.manage_own"] },
  "/prompt-governance": { en: "Prompt review", ar: "مراجعة التعليمات", capabilities: ["prompts.view"] },
  "/domain-egress": { en: "Domain connections", ar: "اتصالات النطاق", capabilities: ["domains.manage_own"] },
  "/content-safety": { en: "Content protection", ar: "حماية المحتوى", capabilities: ["content_safety.read", "content_safety.manage", "domains.manage_own"] },
  "/feedback-curation": { en: "Feedback review", ar: "مراجعة الملاحظات", capabilities: ["feedback.read", "feedback.curate", "domains.manage_own"] },
};

export function governancePageTitle(path: string, locale: string): string | undefined {
  const item = governanceNavigation[path];
  return item ? (locale === "ar" ? item.ar : item.en) : undefined;
}
